export const SystemDefaultType = {
    WALLET_ADDRESS: 'crypto_address',
    COMMISSION_L1: 'commission_l1',
    COMMISSION_L2: 'commission_l2',
    COMMISSION_L3: 'commission_l3',
    COMMISSION_L4: 'commission_l4',
} as const

export type SystemDefaultType = typeof SystemDefaultType[keyof typeof SystemDefaultType]

export type SystemDefault = {
    name: string
    value: string | number | boolean
    description: string
}
